import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import { createIpFilter } from '../../filters/index';
import type { TableColumnFormatLink } from '../../links/TableLink';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';
import { formatValueToCsvString } from './helpers/formatValueToCsvString';
import { mergeFieldDependencies } from './helpers/mergeFieldDependencies';

export type TableColumnFormatNeighborIp<TRow> = {
  type: 'neighborIp';
  field: KeyOfType<TRow, string | null>;
  protocolField: KeyOfType<TRow, string>;
} & TableColumnFormatLink<TRow>;

type neighborIpColumnConfig<TRow, TDataType> = TableDataColumnConfig<
  TRow,
  TDataType
>;

export const createNeighborIpColumn = <TRow>(
  config: neighborIpColumnConfig<TRow, string | null> & {
    protocolField: KeyOfType<TRow, string>;
    array?: false;
  },
): TableColumnBase<TRow, TableColumnFormatNeighborIp<TRow>> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'neighborIp',
    field: config.key,
    protocolField: config.protocolField,
  },
  csvStringDependencies: [config.key],
  webDependencies: mergeFieldDependencies(config.key, config.protocolField),
  toCsvString: (row) =>
    formatValueToCsvString(
      getValueFromKeyOfType<TRow, string | null>(row, config.key),
      (v: string | null): string => v ?? '',
    ),
  filter: createDefaultFilter(config.filter, createIpFilter()),
});
